<template>
    <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in" appear>
            <div>
                <component :is="Component" />
            </div>
        </transition>
    </router-view>
</template>

<script setup>
</script>
